import global from './global';

export default global;
